import { createAction, props } from '@ngrx/store';
import {
  ISubscription,
  UpdateSubscriptionDTO
} from '@care-portals/api-interfaces';

export const getSubscription = createAction(
  '[Subscriptions] Get Subscription',
  props<{ id: string }>()
);

export const getSubscriptionSuccess = createAction(
  '[Subscriptions] Get Subscription Success',
  props<{ subscription: ISubscription }>()
);

export const getSubscriptionFailure = createAction(
  '[Subscriptions] Get Subscription Failure',
  props<{ error: any }>()
);

export const getSubscriptions = createAction(
  '[Subscriptions] Get Subscriptions'
);

export const getSubscriptionsSuccess = createAction(
  '[Subscriptions] Get Subscriptions Success',
  props<{ subscriptions: ISubscription[] }>()
);

export const getSubscriptionsFailure = createAction(
  '[Subscriptions] Get Subscriptions Failure',
  props<{ error: any }>()
);

export const updateSubscription = createAction(
  '[Subscriptions] Update Subscription',
  props<{ id: string; updates: UpdateSubscriptionDTO }>()
);

export const updateSubscriptionSuccess = createAction(
  '[Subscriptions] Update Subscription Success',
  props<{ subscription: ISubscription }>()
);

export const updateSubscriptionFailure = createAction(
  '[Subscriptions] Update Subscription Failure',
  props<{ error: any }>()
);
